<template>
  <div class="progress" :style="`height: ${height}px;`">
    <div
      class="progress-bar"
      role="progressbar"
      :style="`width: ${progressPercent}%;`"
      :aria-valuenow="progressPercent"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>
  </div>
</template>

<script>
export default {
  name: "LendioProgressBar",
  props: ['height', 'progressPercent']
}
</script>

<style lang="scss" scoped>
@import 'lendio-progress';
/* TODO: Remove this once styleguide is updated */
.progress {
  background-color: $background-200;
}

</style>
